<template>
<div class="comment-option">
  <!-- 自分のコメント{{user.member_id === userData.member_id}} <br>
  uuid:{{uuid}}<br>
  reply_key:{{replyKey}} <br> -->
  <button class="btn option-btn" type="button" v-on:click="isShow=!isShow">
    <svg class="icon icon-option" height="4" width="16" fill-rule="evenodd" viewBox="6928 -3223 16 4">
      <title>オプション</title>
      <g transform="translate(6593 -3251)">
        <path d="M6,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,6,10Zm12,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,18,10Zm-6,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z" transform="translate(331 18)"/>
      </g>
    </svg>
  </button>

  <ul class="comment-option-menu" v-if="isShow">
    <!-- <li><router-link :to="'report'">コメントを報告する</router-link></li> -->
    <li class="comment-option-menu__item" v-if="this.userData.member_id !== user.member_id">
      <button class="btn option-btn-report" type="button" @click="commentReport"><span class="btn-text">このコメントを報告する</span></button>
    </li>
    <li class="comment-option-menu__item" v-if="this.userData.member_id === user.member_id">
      <button class="btn option-btn-delete" type="button" @click="commentDelete"><span class="btn-text">削除する</span></button>
    </li>
    <li class="comment-option-menu__item">
        <button class="btn option-btn-cancell" type="button" v-on:click="isShow=false"><span class="btn-text">キャンセル</span></button>
    </li>
  </ul>

  <div class="comment-option__bg" v-if="isShow" v-on:click="isShow=false"></div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'commentOption',
  data: function () {
    return {
      isShow: false
    }
  },
  props: {
    userData: Object,
    uuid: String,
    replyKey: String
  },
  computed: {
    ...mapState('userData', ['user']),
    ...mapState('commentsData', ['entryID'])
  },
  methods: {
    ...mapActions('modal', ['siteloginModal', 'showModalDelete', 'showModalReport', 'siteRankupModal']),
    commentDelete: function () { // コメント削除
      const payload = {
        name: 'modalDelete',
        entryID: this.entryID,
        uuid: this.uuid,
        replyKey: this.replyKey
      }
      // ロール判定
      if (this.user.role === 'low' || this.user.role === 'middle') {
        this.showModalDelete(payload)
      } else if (this.user.idOnly) {
        this.siteRankupModal('newsComment')
      } else {
        this.siteloginModal('newsComment')
      }
      this.isShow = false
    },
    commentReport: function () { // コメント報告
      const payload = {
        name: 'modalReport',
        entryID: this.entryID,
        uuid: this.uuid,
        replyKey: this.replyKey
      }
      // ロール判定
      if (this.user.role === 'low' || this.user.role === 'middle') {
        this.showModalReport(payload)
      } else if (this.user.idOnly) {
        this.siteRankupModal('newsComment')
      } else {
        this.siteloginModal('newsComment')
      }
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" src="./commentOption.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/commentOption/commentOption.vue